import { render } from "./ExternalAuth.vue?vue&type=template&id=698fde0a"
import script from "./ExternalAuth.vue?vue&type=script&lang=js"
export * from "./ExternalAuth.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ergishoxha/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__